/** @jsxRuntime automatic */
import { cn } from "./utils";

const SPINNER_SIZE = { xs: 12, sm: 16, md: 20, lg: 32 } as const;

export interface SpinnerProps {
  /** xs 12 · sm 16 (default, inside buttons) · md 20 · lg 32 (page loads). */
  size?: keyof typeof SPINNER_SIZE;
  /** Accessible name. Without it the spinner is decorative (`aria-hidden`). */
  label?: string;
  className?: string;
}

/**
 * The one loading indicator: a 270° arc in `currentColor` over a faint track.
 * Keeps turning (slower) under reduced motion — see globals.css.
 */
export function Spinner({ size = "sm", label, className }: SpinnerProps) {
  const px = SPINNER_SIZE[size];
  return (
    <svg
      width={px}
      height={px}
      viewBox="0 0 24 24"
      fill="none"
      className={cn("shrink-0 animate-spin [animation-duration:0.7s]", className)}
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    >
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.18" strokeWidth="2.5" />
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeDasharray="42.4 56.6"
        transform="rotate(-90 12 12)"
      />
    </svg>
  );
}
